// import { ControlledDatepickerInputSM } from '@apps-common/components/elements/datepicker/ControlledDatepickerInputSM'
import classNames from 'classnames'

import { useManagementGetUnitTaskGroupTypes } from '@apps-common/apis/management/unit-task/task-groups'
import { ButtonRoundSm, ControlledDatepickerInputSM, ControlledInputDebounced, SelectInputSM } from '@apps-common/components/elements'
import { FilterModalContainer } from '@apps-common/components/modals/filter/FilterModalContainer'
import { ModalBody, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { commonIcons } from '@apps-common/config/icons'
import {
  INPUT_CLASSES,
  INPUT_CONTAINER_CLASSES,
  INPUT_DATEPICKER_CLASSES_SM,
  INPUT_DATEPICKER_CONTAINER_SM
} from '@apps-common/config/input-styles'
import { ModalDismiss } from '@apps-common/config/modal'
import { UNIT_TASK_ORDER_OPTIONS, UNIT_TASK_STATUS_OPTIONS } from '@apps-common/config/unit-task'
import {
  getManagementUnitsFilterDefaultEndDateStr,
  getManagementUnitsFilterDefaultStartDateStr
} from '@apps-common/stores/useManagementUnitsFilterStore'
import {
  getUnitTaskGroupFilterDefaultEndDateStr,
  getUnitTaskGroupFilterDefaultStartDateStr,
  useUnitTaskGroupsFilterStore
} from '@apps-common/stores/useUnitTaskGroupsFilterStore'

export const ProgramTaskGroupFilterModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: any
}) => {
  const state = useUnitTaskGroupsFilterStore()

  const { data: taskTypes, isLoading: taskTypesIsLoading, isError: taskTypesIsError } = useManagementGetUnitTaskGroupTypes({ config: {} })

  const loading = taskTypesIsLoading || taskTypesIsError

  return (
    <FilterModalContainer onDismiss={onDismiss}>
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <ModalHeader subtitle='Device tasks' title='Filter' subtitleClasses='capitalize' />
          <div className='flex items-center gap-[10px]'>
            <ButtonRoundSm
              type='button'
              className='action-brand'
              callback={() => {
                state.clear()
                onDismiss(null, ModalDismiss.Confirm)
              }}
            >
              <commonIcons.reload />
            </ButtonRoundSm>
            <ButtonRoundSm
              type='button'
              className='action-brand-solid'
              callback={() => {
                onDismiss(null, ModalDismiss.Confirm)
              }}
            >
              <commonIcons.close />
            </ButtonRoundSm>
          </div>
        </div>
      </ModalHeaderContainer>
      <ModalBody classes='!pt-[100px] !pb-[30px] sm:!pb-[20px]'>
        <div className='flex flex-col gap-[10px]'>
          {/* TASK GROUP NAME */}
          <ControlledInputDebounced
            label='Name'
            id='unit-task-group-filter-name'
            type='text'
            placeholder='Start typing task name to search'
            showLabel
            className={INPUT_CLASSES}
            containerClassName={INPUT_CONTAINER_CLASSES}
            value={state.groupName}
            disabled={loading}
            onChange={(e) => state.setGroupName(e?.target?.value || '')}
          />
          {/* TASK GROUP STATUS */}
          <SelectInputSM
            label='Status'
            id='unit-task-group-filter-status'
            showLabel
            className={INPUT_CLASSES}
            containerClassName={INPUT_CONTAINER_CLASSES}
            options={UNIT_TASK_STATUS_OPTIONS}
            disabled={loading}
            hideError
            registration={{ value: state.status, onChange: (e: any) => state.setStatus(e?.target?.value || '') }}
          />
          {/* TASK GROUP TYPE */}
          <SelectInputSM
            label='Type'
            id='unit-task-group-filter-type'
            showLabel
            className={INPUT_CLASSES}
            containerClassName={INPUT_CONTAINER_CLASSES}
            options={taskTypes || []}
            disabled={loading}
            registration={{ value: state.status, onChange: (e: any) => state.setTaskType(e?.target?.value || '') }}
          />
          {/* START DATE */}
          <ControlledDatepickerInputSM
            label='Start date'
            id='unit-task-group-filter-start-date'
            name='startDate'
            placeholder='Start date'
            showLabel
            disabled={loading}
            className={INPUT_DATEPICKER_CLASSES_SM}
            containerClassName={INPUT_DATEPICKER_CONTAINER_SM}
            value={state.startDate || getManagementUnitsFilterDefaultStartDateStr()}
            onChange={(value) => state.setStartDate(value)}
            minDate={new Date(getUnitTaskGroupFilterDefaultStartDateStr())}
            maxDate={new Date(getUnitTaskGroupFilterDefaultEndDateStr())}
          />
          {/* END DATE */}
          <ControlledDatepickerInputSM
            label='End date'
            id='unit-task-group-filter-end-date'
            name='endDate'
            placeholder='End date'
            showLabel
            disabled={loading}
            className={INPUT_DATEPICKER_CLASSES_SM}
            containerClassName={INPUT_DATEPICKER_CONTAINER_SM}
            value={state.endDate || getManagementUnitsFilterDefaultEndDateStr()}
            onChange={(value) => state.setStartDate(value)}
            minDate={new Date(getManagementUnitsFilterDefaultStartDateStr())}
            maxDate={new Date(getManagementUnitsFilterDefaultEndDateStr())}
          />
          <SelectInputSM
            placeholder='Order by'
            label='Order by'
            id='unit-task-group-filter-order-by'
            showLabel
            className={INPUT_CLASSES}
            containerClassName={classNames(INPUT_CONTAINER_CLASSES, 'sm:col-span-2')}
            options={UNIT_TASK_ORDER_OPTIONS}
            disabled={loading}
            registration={{ value: state.orderBy, onChange: (e: any) => state.setOrderBy(e?.target?.value || '') }}
          />
        </div>
      </ModalBody>
    </FilterModalContainer>
  )
}
